import Swiper, { Navigation, Pagination, Autoplay } from "swiper"

Swiper.use([Navigation, Pagination, Autoplay])

const initClientsSwiper = () => {
  new Swiper(".clients-swiper", {
    autoplay: true,
    loop: true,
    slidesPerView: "auto",
    watchSlidesVisibility: true,
    centeredSlides: true,

    pagination: {
      el: ".swiper-pagination",
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  })
}

export default initClientsSwiper
